/* =========================================================================
   LP B2B "Seja um Lojista Guday"  —  JS escopado
   - Acordeão FAQ (button-based, igual ao idiom da lp-guday.js)
   - Smooth-scroll dos CTAs até o form
   Bootstrap em DOMContentLoaded + shopify:section:load (theme editor).
   ========================================================================= */
(function () {
  function init(root) {
    if (!root || root.dataset.lpb2bInit === '1') return;
    root.dataset.lpb2bInit = '1';

    /* ============== FAQ ACCORDION ============== */
    root.querySelectorAll('.lp-b2b-faq-item').forEach(function (item) {
      var q = item.querySelector('.lp-b2b-faq-q');
      if (!q) return;
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('lp-b2b-open');
        // fecha os outros (acordeão single-open)
        root.querySelectorAll('.lp-b2b-faq-item.lp-b2b-open').forEach(function (o) {
          if (o !== item) {
            o.classList.remove('lp-b2b-open');
            var ob = o.querySelector('.lp-b2b-faq-q');
            if (ob) ob.setAttribute('aria-expanded', 'false');
          }
        });
        item.classList.toggle('lp-b2b-open', !isOpen);
        q.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    /* ============== SMOOTH SCROLL CTAs -> FORM ============== */
    root.querySelectorAll('[data-lp-scroll]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var target = root.querySelector(href);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    /* ============== FORM CHIPS (toggle visual + single-select radios) ============== */
    root.querySelectorAll('.lp-b2b-chip').forEach(function (chip) {
      var input = chip.querySelector('input');
      if (!input) return;
      function sync() {
        if (input.type === 'radio') {
          // radio: limpa o "on" dos irmãos do mesmo name
          root.querySelectorAll('input[name="' + input.name + '"]').forEach(function (sib) {
            var lbl = sib.closest('.lp-b2b-chip');
            if (lbl) lbl.classList.toggle('lp-b2b-on', sib.checked);
          });
        } else {
          chip.classList.toggle('lp-b2b-on', input.checked);
        }
      }
      input.addEventListener('change', sync);
      sync();
    });

    /* ============== CNPJ MASK + AUTOPREENCHIMENTO (BrasilAPI, sem backend) ============== */
    var cnpj = root.querySelector('input[name="cnpj"]');
    if (cnpj) {
      cnpj.addEventListener('input', function () {
        var v = cnpj.value.replace(/\D/g, '').slice(0, 14);
        v = v.replace(/^(\d{2})(\d)/, '$1.$2')
             .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
             .replace(/\.(\d{3})(\d)/, '.$1/$2')
             .replace(/(\d{4})(\d)/, '$1-$2');
        cnpj.value = v;
        // dispara a busca assim que completa os 14 dígitos
        if (v.replace(/\D/g, '').length === 14) buscarCNPJ(cnpj.value);
      });
      // fallback: busca também ao sair do campo
      cnpj.addEventListener('blur', function () { buscarCNPJ(cnpj.value); });
    }

    var lastCnpj = '';   // evita refazer a mesma busca
    var buscando = false;

    // preenche um campo SÓ se estiver vazio (não sobrescreve digitação manual)
    function fill(name, value) {
      if (value == null || value === '' || value === '0') return false;
      var el = root.querySelector('input[name="' + name + '"]');
      if (!el || el.value.trim()) return false;
      el.value = value;
      el.classList.remove('lp-b2b-invalid');
      el.classList.add('lp-b2b-autofilled');
      setTimeout(function () { el.classList.remove('lp-b2b-autofilled'); }, 1600);
      return true;
    }

    function buscarCNPJ(raw) {
      var limpo = (raw || '').replace(/\D/g, '');
      if (limpo.length !== 14 || limpo === lastCnpj || buscando) return;
      lastCnpj = limpo;
      buscando = true;
      if (cnpj) cnpj.classList.add('lp-b2b-loading');

      fetch('https://brasilapi.com.br/api/cnpj/v1/' + limpo)
        .then(function (res) {
          if (!res.ok) throw new Error('cnpj ' + res.status);
          return res.json();
        })
        .then(function (data) {
          fill('loja', data.nome_fantasia || data.razao_social);
          var cepFmt = (data.cep || '').replace(/\D/g, '').replace(/^(\d{5})(\d{3})$/, '$1-$2');
          fill('cep', cepFmt);
          fill('rua', data.logradouro);
          fill('numero', data.numero);
          fill('bairro', data.bairro);
          fill('cidade', data.municipio);
          fill('estado', data.uf);
        })
        .catch(function (e) {
          // não bloqueia o form — usuário preenche manualmente
          console.warn('[CNPJ] autopreenchimento indisponível:', e.message);
          lastCnpj = ''; // permite tentar de novo
        })
        .then(function () {
          buscando = false;
          if (cnpj) cnpj.classList.remove('lp-b2b-loading');
        });
    }

    /* ============== SUBMIT -> grava na planilha (Apps Script) + estado de sucesso ============== */
    var card = root.querySelector('.lp-b2b-form-card');
    var form = card && card.querySelector('.lp-b2b-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        // valida os campos required visualmente
        var ok = true;
        form.querySelectorAll('input[required]').forEach(function (input) {
          var empty = !input.value.trim();
          input.classList.toggle('lp-b2b-invalid', empty);
          if (empty && ok) {
            ok = false;
            input.focus();
          }
        });
        if (!ok) return;

        var submitBtn = form.querySelector('.lp-b2b-form-submit');
        var endpoint = (form.getAttribute('data-endpoint') || '').trim();

        // dispara o evento de Lead no Facebook Pixel (via GTM/fbq) — só 1x por submit,
        // só quando o lead foi de fato enviado pro Apps Script (planilha).
        var leadFired = false;
        function fireLeadEvent() {
          if (leadFired) return;
          leadFired = true;
          try {
            if (typeof window.fbq === 'function') {
              window.fbq('track', 'Lead', { content_name: 'Seja um Lojista Guday', content_category: 'B2B' });
            }
          } catch (err) { /* não trava o fluxo se o pixel não estiver pronto */ }
        }

        // mostra o sucesso visual; se houver endpoint, dispara o POST em paralelo.
        function showSuccess() {
          card.classList.add('is-success');
          card.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        if (!endpoint) {
          // sem endpoint configurado: só estado de sucesso (igual ao comportamento anterior)
          showSuccess();
          return;
        }

        // ---- micro-feedback: botão entra em "Processando..." durante o envio ----
        var btnLabel = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.classList.add('lp-b2b-loading-btn');
          submitBtn.textContent = 'Processando...';
        }
        var payload = collectFormData(form);
        // tempo mínimo de exibição do estado pra o feedback não "piscar"
        // (o no-cors costuma resolver em ms; sem isso o "Processando..." nem apareceria)
        var startedAt = Date.now();
        function finish(done) {
          var elapsed = Date.now() - startedAt;
          var wait = Math.max(0, 600 - elapsed);
          setTimeout(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.classList.remove('lp-b2b-loading-btn');
              submitBtn.textContent = btnLabel;
            }
            done();
          }, wait);
        }

        // Apps Script /exec não devolve headers CORS -> usamos no-cors + text/plain
        // (evita preflight; não conseguimos ler a resposta, mas o appendRow grava).
        fetch(endpoint, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(payload)
        })
          .then(function () { fireLeadEvent(); finish(showSuccess); })
          .catch(function (err) {
            // não trava o usuário se a rede/endpoint falhar: ainda mostra o sucesso
            // (o lead pode ter sido gravado mesmo com no-cors). Log pra debug.
            // dispara o Lead mesmo no catch: com no-cors o appendRow costuma gravar.
            console.warn('[lp-b2b] falha ao enviar lead:', err);
            fireLeadEvent();
            finish(showSuccess);
          });
      });
      form.querySelectorAll('input').forEach(function (input) {
        input.addEventListener('input', function () { input.classList.remove('lp-b2b-invalid'); });
      });
    }
  }

  /* Monta o objeto enviado pro Apps Script a partir dos campos do form.
     - inputs de texto -> string (pelo name)
     - ramo[]/comercializo[] (checkbox) -> array de valores marcados
     - status (radio) -> string única
     - origem -> data-source do form (ou window.__lpSource) */
  function collectFormData(form) {
    var data = {};
    form.querySelectorAll('input[name]').forEach(function (input) {
      var name = input.name;
      if (input.type === 'checkbox') {
        if (!input.checked) return;
        var key = name.replace(/\[\]$/, '');         // ramo[] -> ramo
        if (!data[key]) data[key] = [];
        data[key].push(input.value);
      } else if (input.type === 'radio') {
        if (input.checked) data[name] = input.value;  // status
      } else {
        data[name] = input.value.trim();
      }
    });
    data.origem = form.getAttribute('data-source') || window.__lpSource || 'lp-sejaumlojista';
    return data;
  }

  function bootstrap() {
    document.querySelectorAll('.lp-b2b-wrap').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
  // Re-init quando o theme editor recarrega a section
  document.addEventListener('shopify:section:load', bootstrap);
})();
